import { FC, SVGProps } from "react";
import clsx from "clsx";

// ----------------------------------------------------------------------------------

export type IGmailProps = SVGProps<SVGSVGElement> & {
  variant: "white" | "black" | "normal";
};

const Gmail: FC<IGmailProps> = (props) => {
  const { variant, className, ...other } = props;

  return (
    <>
      {variant === "white" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 33 26"
          fill="none"
          className={clsx("rounded-sm bg-white p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6787)">
            <path
              d="M2.25 25.5001H7.5V12.6213L0 6.93945V23.2273C0 24.4849 1.00875 25.5001 2.25 25.5001Z"
              fill="#054ADA"
            />
            <path
              d="M25.5 25.5001H30.75C31.995 25.5001 33 24.4811 33 23.2273V6.93945L25.5 12.6213"
              fill="#054ADA"
            />
            <path
              d="M25.5 2.77283V12.6213L33 6.93949V3.90919C33 1.09858 29.8237 -0.503688 27.6 1.18192"
              fill="#054ADA"
            />
            <path
              d="M7.5 12.6212V2.77271L16.5 9.59089L25.5 2.77271V12.6212L16.5 19.4394"
              fill="#054ADA"
            />
            <path
              d="M0 3.90919V6.93949L7.5 12.6213V2.77283L5.4 1.18192C3.1725 -0.503688 0 1.09858 0 3.90919Z"
              fill="#054ADA"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6787">
              <rect
                width="33"
                height="25"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "black" && (
        <svg
          width="25"
          height="25"
          viewBox="0 0 33 26"
          fill="none"
          className={clsx("rounded-sm bg-black-900 p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6787)">
            <path
              d="M2.25 25.5001H7.5V12.6213L0 6.93945V23.2273C0 24.4849 1.00875 25.5001 2.25 25.5001Z"
              fill="#EFFBFF"
            />
            <path
              d="M25.5 25.5001H30.75C31.995 25.5001 33 24.4811 33 23.2273V6.93945L25.5 12.6213"
              fill="#EFFBFF"
            />
            <path
              d="M25.5 2.77283V12.6213L33 6.93949V3.90919C33 1.09858 29.8237 -0.503688 27.6 1.18192"
              fill="#EFFBFF"
            />
            <path
              d="M7.5 12.6212V2.77271L16.5 9.59089L25.5 2.77271V12.6212L16.5 19.4394"
              fill="#EFFBFF"
            />
            <path
              d="M0 3.90919V6.93949L7.5 12.6213V2.77283L5.4 1.18192C3.1725 -0.503688 0 1.09858 0 3.90919Z"
              fill="#EFFBFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6787">
              <rect
                width="33"
                height="25"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "normal" && (
        <svg
          width="33"
          height="26"
          viewBox="0 0 33 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6787)">
            <path
              d="M2.25 25.5001H7.5V12.6213L0 6.93945V23.2273C0 24.4849 1.00875 25.5001 2.25 25.5001Z"
              fill="#9B9B9B"
            />
            <path
              d="M25.5 25.5001H30.75C31.995 25.5001 33 24.4811 33 23.2273V6.93945L25.5 12.6213"
              fill="#6E6E6E"
            />
            <path
              d="M25.5 2.77283V12.6213L33 6.93949V3.90919C33 1.09858 29.8237 -0.503688 27.6 1.18192"
              fill="#808080"
            />
            <path
              d="M7.5 12.6212V2.77271L16.5 9.59089L25.5 2.77271V12.6212L16.5 19.4394"
              fill="#909090"
            />
            <path
              d="M0 3.90919V6.93949L7.5 12.6213V2.77283L5.4 1.18192C3.1725 -0.503688 0 1.09858 0 3.90919Z"
              fill="#727272"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6787">
              <rect
                width="33"
                height="25"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default Gmail;
